import type { AdItem } from '@sbt-web/network/types';
import { getCategory } from '@sbt-web/tracking';
import { transformAds } from '@/tools/tracking/transformer';
import { getOrCreatePulse } from '@/tools/tracking/utils';

const trackCardClick = (item: AdItem, rank: number): void => {
  const { urn, subject: name, category } = item;
  getOrCreatePulse()?.queueEvent({
    type: 'Click',
    object: {
      type: 'ClassifiedAd',
      id: urn,
      name,
      category: getCategory(category.id) || '',
      'spt:custom': {
        listing_section: 'detail_recommender',
        rank,
      },
    },
  });
};

const trackCardImpression = (item: AdItem, rank: number): void => {
  const { urn, subject: name, category } = item;

  getOrCreatePulse()?.queueEvent({
    type: 'Watch',
    object: {
      type: 'ClassifiedAd',
      id: urn,
      name,
      category: getCategory(category.id) || '',
      'spt:custom': {
        listing_section: 'detail_recommender',
        rank,
      },
    },
  });
};

const trackCarouselImpression = (
  target: AdItem,
  items: Array<AdItem>
): void => {
  getOrCreatePulse()?.queueEvent({
    type: 'Watch',
    object: {
      '@type': 'RecommendationList',
      '@id': `sdrn:subito:classified:${target.urn}:element:detail-recommender`,
      numItems: items.length,
      items: transformAds(items, { name: 'classified' }),
    },
  });
};

export { trackCardImpression, trackCardClick, trackCarouselImpression };
